import { call, put } from "redux-saga/effects";
import httpErrorHelpers from "../../services/httpUtilities/httpErrorHelpers";
import api from "../../services/httpUtilities/httpService";
import * as policyAction from "../actions/policy";

function* watcherGetPaymentStatusMessage({ Id }, effects) {
  try {
    const response = yield call(api.getPaymentStatusMessage, Id);
    const { data, status } = response;
    const { Message } = data;

    if (status === 200) {
      yield put(policyAction.getPaymentStatusMessageSuccess(Message));
    } else {
      const message = "Get Inquiry List Unsuccessful";
      yield put(policyAction.getPaymentStatusMessageFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      policyAction.getPaymentStatusMessageFailure,
      effects
    );
  }
}

function* watcherGetChatConfiguration({}, effects) {
  try {
    const response = yield call(api.getChatConfiguration);
    const { data, status } = response;
    const { Message } = data;

    if (status === 200) {
      yield put(policyAction.getChatConfigurationSuccess(data));
    } else {
      const message = "Get Config Unsuccessful";
      yield put(policyAction.getChatConfigurationFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      policyAction.getChatConfigurationFailure,
      effects
    );
  }
}

function* watcherGetCreateChat({ sessionId }, effects) {
  try {
    const response = yield call(api.getCreateChat, sessionId);
    const { data, status } = response;
    const { Message } = data;

    if (status === 200) {
      yield put(policyAction.getCreateChatSuccess(data));
    } else {
      const message = "Get Config Unsuccessful";
      yield put(policyAction.getCreateChatFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      policyAction.getCreateChatFailure,
      effects
    );
  }
}

function* watcherGetChatUpdate({ threadID, loginId }, effects) {
  try {
    const response = yield call(api.getChatUpdate, threadID, loginId);
    const { data, status } = response;
    const { Message } = data;

    if (status === 200) {
      yield put(policyAction.getChatUpdateSuccess(data));
    } else {
      const message = "Get Config Unsuccessful";
      yield put(policyAction.getChatUpdateFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      policyAction.getChatUpdateFailure,
      effects
    );
  }
}

function* watcherGetChatMessage({ threadID,loginId }, effects) {
  try {
    const response = yield call(api.getChatMessage, threadID,loginId);
    const { data, status } = response;
    const { Message } = data;

    if (status === 200) {
      yield put(policyAction.getChatMessageSuccess(data));
    } else {
      const message = "Get Config Unsuccessful";
      yield put(policyAction.getChatMessageFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      policyAction.getChatMessageFailure,
      effects
    );
  }
}

function* watcherGetCreateMessage(
  { threadID, content, messageType, payload, attachedFiles, intent, level,loginId },
  effects
) {
  try {
    const response = yield call(
      api.getCreateMessage,
      threadID,
      content,
      messageType,
      payload,
      attachedFiles,
      intent,
      level,
      loginId
    );
    const { data, status } = response;
    const { Message } = data;

    if (status === 200) {
      yield put(policyAction.getCreateMessageSuccess(data));
    } else {
      const message = "Get Config Unsuccessful";
      yield put(policyAction.getCreateMessageFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      policyAction.getCreateMessageFailure,
      effects
    );
  }
}

function* watcherGetTwilioQuitQueue({ threadID }, effects) {
  try {
    const response = yield call(api.getTwilioQuitQueue, threadID);
    const { data, status } = response;
    const { Message } = data;

    if (status === 200) {
      yield put(policyAction.getTwilioQuitQueueSuccess(data));
    } else {
      const message = "Get Twilio Queue Quit Failed";
      yield put(policyAction.getTwilioQuitQueueFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      policyAction.getTwilioQuitQueueFailure,
      effects
    );
  }
}

function* watcherGetScheduleCallBack({ threadID }, effects) {
  try {
    const response = yield call(api.getScheduleCallBack, threadID);
    const { data, status } = response;
    const { Message } = data;

    if (status === 200) {
      yield put(policyAction.getScheduleCallBackSuccess(data));
    } else {
      const message = "Get Schedule Call b Failed";
      yield put(policyAction.getScheduleCallBackFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      policyAction.getScheduleCallBackFailure,
      effects
    );
  }
}

function* watcherGetDisabledTimeLists({ date }, effects) {
  try {
    const response = yield call(api.getDisabledTimeLists, date);
    const { data, status } = response;
    const { Message } = data;

    if (status === 200) {
      yield put(policyAction.getDisabledTimeListsSuccess(data));
    } else {
      const message = "Get Disabled Time Failed";
      yield put(policyAction.getDisabledTimeListsFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      policyAction.getDisabledTimeListsFailure,
      effects
    );
  }
}

function* watcherCreateAppointment(
  { threadID, bookSTime, bookETime, customerN, email, mobile },
  effects
) {
  try {
    const response = yield call(
      api.createAppointment,
      threadID,
      bookSTime,
      bookETime,
      customerN,
      email,
      mobile
    );
    const { data, status } = response;
    const { Message } = data;

    if (status === 200) {
      yield put(policyAction.createAppointmentSuccess(data));
    } else {
      const message = "Get createAppointmentFailure Failed";
      yield put(policyAction.createAppointmentFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      policyAction.createAppointmentFailure,
      effects
    );
  }
}
//Get Profile INFO
function* watcherGetProfile({ nric }, effects) {
  try {
    const response = yield call(api.getProfile, nric);
    const { data, status } = response;
    //console.log("res",response)
    if (status === 200) {
      yield put(policyAction.getProfileListSuccess(data.Data));
    } else {
      const message = "Get Activity List Unsuccessful";
      yield put(policyAction.getProfileListFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      policyAction.getProfileListFailure,
      effects
    );
  }
}

//GET_CHAT_REPLY_STATUS
function* watcherGetChatReplyStatus({chatid, feedbackStatus}, effects) {
  try {
    const response = yield call(api.getChatReplyStatus,chatid, feedbackStatus);
    const { data, status } = response;
    const { Data, Status, Message, Success } = data;

    if (Success) {
      yield put(policyAction.getChatReplyStatusSuccess(data));
    } else {
      const message = "getSharePolicyPendingListFailure";
      yield put(
        policyAction.getChatReplyStatusFailure(
          Message ? Message : message
        )
      );
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      policyAction.getChatReplyStatusFailure,
      effects
    );
  }
}

//Connect Live Chat
function* watcherConnectLiveChat({threadID}, effects) {
  try {
    const response = yield call(api.connectLiveChat,threadID);
    const { data, status } = response;
    const { Data, Status, Message, Success } = data;

    if (Success) {
      yield put(policyAction.connectLiveChatSuccess(data));
    } else {
      const message = "getSharePolicyPendingListFailure";
      yield put(
        policyAction.connectLiveChatFailure(
          Message ? Message : message
        )
      );
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      policyAction.connectLiveChatFailure,
      effects
    );
  }
}

//Get Insider Client Info
function* watcherGetInsiderClientInfoReq({}, effects) {
  try {
    const response = yield call(api.getInsiderClientInfoReq);
    const { data, status } = response;
    //console.log("res",response)
    if (status === 200) {
      yield put(policyAction.getInsiderClientInfoReqSuccess(data.Data));
    } else {
      const message = "getInsiderClientInfoReqFailure Unsuccessful";
      yield put(policyAction.getInsiderClientInfoReqFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      policyAction.getInsiderClientInfoReqFailure,
      effects
    );
  }
}

//Get Insider Client Info
function* watcherSingtelPartnershipLeadsReq({submitData}, effects) {
  try {
    const response = yield call(api.singtelPartnershipLeadsReq,submitData);
    const { data, status } = response;
    //console.log("res",response)
    if (status === 200) {
      yield put(policyAction.singtelPartnershipLeadsReqSuccess(data.Data));
    } else {
      const message = "singtelPartnershipLeadsReqFailure Unsuccessful";
      yield put(policyAction.singtelPartnershipLeadsReqFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      policyAction.singtelPartnershipLeadsReqFailure,
      effects
    );
  }
}

export {
  watcherGetPaymentStatusMessage,
  watcherGetChatConfiguration,
  watcherGetCreateChat,
  watcherGetChatUpdate,
  watcherGetChatMessage,
  watcherGetCreateMessage,
  watcherGetTwilioQuitQueue,
  watcherGetScheduleCallBack,
  watcherGetDisabledTimeLists,
  watcherCreateAppointment,
  watcherGetProfile,
  watcherGetChatReplyStatus,
  watcherConnectLiveChat,
  watcherGetInsiderClientInfoReq,
  watcherSingtelPartnershipLeadsReq
};
